var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.routerView)?_c('div',{staticClass:"app-main-container"},[_c('transition',{attrs:{"mode":"out-in","name":"fade-transform"}},[_c('keep-alive',{attrs:{"include":_vm.cachedRoutes,"max":_vm.keepAliveMaxNum}},[_c('router-view',{key:_vm.key,staticClass:"app-main-height"})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }